import styled from "styled-components";

export const Label = styled.div`
  margin-bottom: 12px;
`;
